module.exports = __webpack_public_path__ + "static/media/blue_nebula_BK.64560426.png";